import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { ActivatedRoute, GuardsCheckEnd, Router } from '@angular/router';

import { MyProgram } from 'src/app/models/system/my-program.model';
import { MyProgramState } from 'src/app/selectors/system/my-program.selector';

import { getMyPrograms } from 'src/app/selectors/system/my-program.selector';
import * as myProgramActions from 'src/app/actions/system/my-program.actions';
import {
    getLoading,
    OverlayLoadingState,
} from '@app/selectors/overlay-loading.selector';
import { MyProgramConstant } from '@app/common/constant/my-program.constant';
import { Node } from '@app/models/components/node.model';
import { ValidationUtil } from '@app/common/util/validation.util';
import { PageHeadingState } from '@app/selectors/page-heading.selector';
import {
    setPageHeading,
    setShowPageHeading,
    setTypePageHeading,
} from '@app/actions/page-heading.action';
import { setShowOverlayLoading } from '@app/actions/overlay-loading.action';
import { AuthUtil } from '@app/common/util/auth.util';
import {
    CartState,
    getActionResult,
    getCartInfo,
    getCartItems,
    getIsBuyNow,
    getReload,
    getShowAlert,
} from '@app/selectors/shoppingmall/cart.selector';
import { OrdPdtModel } from '@app/models/shoppingmall/order-pdt.model';
import { OrderMstModel } from '@app/models/myoffice/order/order-mst.model';
import { ResultProc } from '@app/models/system/result-proc.model';
import {
    loadCartInfo,
    loadCartItems,
    setReload,
} from '@app/actions/shoppingmall/cart.action';
import { ConvertUtil } from '@app/common/util/convert.util';
import { MemberModel } from '@app/models/system/member.model';
import { PageHeadingConstants } from '@app/common/constant/page-heading.constant';
import {
    getSmWownet,
    getSmWownetPg,
    SmWownetState,
} from '@app/selectors/system/sm-wownet.selector';
import {
    loadFindPayHeader,
    loadSmWownet,
    loadSmWownetPg,
    loadWowWord,
} from '@app/actions/system/sm-wownet.action';
import { Login2State } from '@app/selectors/system/login2.select';
import { logout } from '@app/actions/system/login2.action';
import { getWAlertStatus, WAlertState } from '@app/selectors/w-alert.selector';
import { WAlertStatus } from '@app/models/components/w-alert-stauts.model';
import { setWAlert } from '@app/actions/w-alert.action';
import { WAlertConstant } from '@app/common/constant/w-alert-icon.constant';
import {
    getPdtCates,
    PdtCateState,
} from '@app/selectors/shoppingmall/pdt-cate.selector';
import { loadPdtCate } from '@app/actions/shoppingmall/pdt-cate.action';
import {
    getMemberPoint,
    MemberPointState,
} from '@app/selectors/shoppingmall/member-point.selector';
import { loadMemberPoint } from '@app/actions/shoppingmall/member-point.action';
import { SmWownetPgModel } from '@app/models/system/sm-wownet-pg.model';
import { PdtCateModel } from '@app/models/shoppingmall/pdt-cate.model';
import { SmWownetModel } from '@app/models/system/sm-wownet.model';
import { CheckUseridConstant } from '@app/common/constant/check-userid.constant';
import { SelectDropdownModel } from '@app/models/components/select-dropdown.model';
import { LangConstant } from '@app/common/constant/lang.constant';
import { environment } from '@enviroments/environment';
import { CommonUtils } from '@app/common/util/common.util';
import { HttpClient } from '@angular/common/http';
import { getPdtCate, ProductState } from '@app/selectors/shoppingmall/product.selector';
import { setCateCd, setPdtCate } from '@app/actions/shoppingmall/product.action';

declare const addEventListenerForMobileMenu: any;
declare const addEventListenerClickButtonSearch: any;
declare const clickBtnSearchClose: any;
declare const backToTop: any;
declare const updateMainSidebarWitdth: any;
declare const adjustSidebarActiveMenuItemLiPosition: any;
declare const baseJS: any;
@Component({
    selector: 'hp-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
    myPrograms$ = new Observable<MyProgram[]>();

    pdtCates$ = new Observable<PdtCateModel[]>();
    pdtCates: PdtCateModel[] = [];

    cartItems$ = new Observable<OrdPdtModel[]>();
    cartInfo$ = new Observable<OrderMstModel>();
    actionResult$ = new Observable<ResultProc>();
    cartInfo: OrderMstModel = {} as OrderMstModel;
    isLoadCartItems: boolean = false;
    isBuyNow: boolean = false;
    showAlert: boolean = false;

    leftmenu: MyProgram[] = [];
    rightMenu: MyProgram[] = [];
    mainMenu: MyProgram[] = [];
    mainMenuHome: MyProgram[] = [];
    subMenu: MyProgram[] = [];
    mainItems: Node<MyProgram>[] = [];
    treeMainMenu: Map<String, Node<MyProgram>> = new Map();

    activeId: string = '';
    activeChildId: string = '';
    tempActiveId: string = '';
    activeTopLeft: string = '';

    loading: boolean = false;

    baseUrl: string = '';
    url: string = '';

    openedId: string = '';

    isLogined: boolean = false;
    loginedInfo: MemberModel | null = null;

    key: string = '';
    sumPdtCnt: Number = 0;

    wAlertStatus$ = new Observable<WAlertStatus>();

    memberPoint$ = new Observable<OrderMstModel>();
    memberPoint: OrderMstModel = {} as OrderMstModel;

    smWownetPg$ = new Observable<SmWownetPgModel>();
    smWownetPg: SmWownetPgModel = {} as SmWownetPgModel;

    smWownet$ = new Observable<SmWownetModel>();

    showOptions: Boolean = false;
    options: SelectDropdownModel[] = [
        //{ label: 'ENG', value: 'en' },
        { label: 'KR', value: 'kr' },
        { label: 'US', value: 'en' },
        { label: 'JP', value: 'jp' },
        { label: 'TH', value: 'th' },
    ];
    selected: SelectDropdownModel = new SelectDropdownModel();

    kind: string = "";

    userKind: string = '';
    rankCd: string = '';

    urlMyOffice: string = MyProgramConstant.urlMyOffice;
    urlShopping: string = MyProgramConstant.urlShopping;
    kindMenuHome: string = MyProgramConstant.kindMenuHome;
    kindMenuTopLeft: string = MyProgramConstant.kindMenuTopLeft;
    kindMenuTopRight: string = MyProgramConstant.kindMenuTopRight;
    kindMenuOffice: string = MyProgramConstant.kindMenuOffice;
    kindMenuShopping: string = MyProgramConstant.kindMenuShopping;
    kindMenuFooter: string = MyProgramConstant.kindMenuFooter;
    kindSidebar: string = MyProgramConstant.kindSidebar;
    officeId: string = MyProgramConstant.officeId;
    shoppingId: string = MyProgramConstant.shoppingId;
    homeId: string = MyProgramConstant.homeId;
    urlAbout: string = MyProgramConstant.urlAbout;
    urlCompany: string = MyProgramConstant.urlCompany;
    about: string = MyProgramConstant.about;
    kindMenuAbout: string = MyProgramConstant.kindAbout;

    chkMemEdu: string = "N";
    flagJS: number = 0;
    menuHeaderName: string = '';
    activeCate: string = '';
    activeCateName: string = '';
    pdtCate$ = new Observable<string>();
    cateDefault: string = '0101';

    currentName: string = "";
    memberNames: string[] = ['Member 1', 'Member 2', 'Member 3', 'Member 4', 'Member 5'];
    currentIndex: number = 0;



    constructor(
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _loginStore: Store<Login2State>,
        private _myProgramStore: Store<MyProgramState>,
        private _cartStore: Store<CartState>,
        private _pageHeadingStore: Store<PageHeadingState>,
        private _overlayLoadingStore: Store<OverlayLoadingState>,
        private _wAlertStore: Store<WAlertState>,
        private _smWownetStateStore: Store<SmWownetState>,
        private _pdtCateStore: Store<PdtCateState>,
        private _memberPointStore: Store<MemberPointState>,
        private elementRef: ElementRef,
        private _http: HttpClient,
        private _productStore: Store<ProductState>,
    ) {
        this.myPrograms$ = this._myProgramStore.select(getMyPrograms);
        this.cartItems$ = this._cartStore.select(getCartItems);
        this.cartInfo$ = this._cartStore.select(getCartInfo);
        this.actionResult$ = this._cartStore.select(getActionResult);
        this.wAlertStatus$ = this._wAlertStore.select(getWAlertStatus);
        this.memberPoint$ = this._memberPointStore.select(getMemberPoint);
        this.smWownetPg$ = this._smWownetStateStore.select(getSmWownetPg);
        this.pdtCates$ = this._pdtCateStore.select(getPdtCates);
        this.smWownet$ = this._smWownetStateStore.select(getSmWownet);
        this.pdtCate$ = this._pdtCateStore.select(getPdtCate);
    }

    ngOnInit(): void {
        if (AuthUtil.isLogined()) {
            let member = AuthUtil.getLoginedInfo();
            this.userKind = ConvertUtil.convertToSring(member?.userKind).substr(3, 3);
            this.rankCd = ConvertUtil.convertToSring(member?.rankCd).substr(2, 2);

        }
        this._http.get(`${environment.apiUrl}/product/chkMemEdu?comId=${environment.comId}&userid=${AuthUtil.getLoginedInfo()?.userid}`, { responseType: 'text' }).subscribe((response: string) => {

            this.chkMemEdu = response;

        }, (error) => {
            console.error(error);
        })

        this.handleSetLang();
        this.handleOnActiveLangItem();
        this._smWownetStateStore.dispatch(loadSmWownet());
        this._smWownetStateStore.dispatch(loadFindPayHeader());
        this._smWownetStateStore.dispatch(loadWowWord());
        this._smWownetStateStore.dispatch(loadSmWownetPg());
        this._pdtCateStore.dispatch(loadPdtCate({ key: '' }));

        this.pdtCate$.subscribe(res => {
            if (ValidationUtil.isNotNullAndNotEmpty(res)) {
                for (const item of this.pdtCates) {
                    if (res == item.cateCd) {
                        this.activeCateName = ConvertUtil.convertToSring(item.cateName);
                    }
                }
            }
        });

        this.smWownet$.subscribe((res) =>
            sessionStorage.setItem(CheckUseridConstant.muserPid, res.mUsePId)
        );

        this._activatedRoute.queryParams.subscribe((params) => {
            this.key = ConvertUtil.convertToSring(params['key']);
        });

        this._router.events.forEach((_event) => {
            if (_event instanceof GuardsCheckEnd) {
                this.initMainMenu(this.removeUrlParams(_event.url));
                setTimeout(() => {
                    if (typeof backToTop === 'function') {
                        backToTop();
                    }
                }, 200);
            }
        });

        this._overlayLoadingStore.dispatch(
            setShowOverlayLoading({ loading: true })
        );
        this._myProgramStore.dispatch(myProgramActions.loadMyPrograms());

        this.myPrograms$.subscribe((res) => {
            if (this.isLogined) {
                if (this.rankCd == '00') {
                    res = res.filter((y) => y.prgId != 'ml.Office.Benefit-management' && y.prgId != 'mr.Member-register')
                }
                if (this.rankCd == '01') {
                    res = res.filter((y) => y.prgId != 'ml.Office.Benefit-management')
                }
            }

            this.leftmenu = res.filter(
                (y) => y.prgKind == this.kindMenuTopLeft
            );
            this.rightMenu = res.filter(
                (y) => y.prgKind == this.kindMenuTopRight
            );
            this.mainMenu = res.filter(
                (y) =>
                    y.prgKind == this.kindMenuHome ||
                    y.prgKind == this.kindMenuOffice ||
                    y.prgKind == this.kindMenuShopping ||
                    y.prgKind == this.kindMenuFooter
            );
            this.mainMenuHome = res.filter((y) => y.prgKind == this.kindMenuHome);

            this._overlayLoadingStore.dispatch(
                setShowOverlayLoading({ loading: false })
            );
            this.initMainMenu(window.location.pathname);
        });

        this.pdtCates$.subscribe((res) => {
            //res = res.filter(x => x.cateCd != '0101')
            // if (!this.isLogined || (this.isLogined && this.rankCd == '00')){
            //   let arrayCateCdHide = ['0101','0102','0110','0190']
            //   res = res.filter(
            //     (y)=>arrayCateCdHide.indexOf(y.cateCd)===-1
            //   );
            // }

            if (this.chkMemEdu == 'N') {
                this.pdtCates = res.filter(
                    (y) => y.cateCd !== '0115'
                );
            } else {
                this.pdtCates = res;
            }
        });

        this.smWownetPg$.subscribe((res) => (this.smWownetPg = res));

        this.actionResult$.subscribe((res) => {
            if (res.retCode === 'OK') {
                if (this.isBuyNow) {
                    this._router.navigate([MyProgramConstant.urlShopping + '/checkout']);
                } else {
                    if (this.showAlert) {
                        this._wAlertStore.dispatch(
                            setWAlert({
                                wAlert: {
                                    icon: WAlertConstant.cart,
                                    message: ConvertUtil.convertToSring(res.retStr)
                                },
                            })
                        );
                    }
                }
                this.loadCart();
            } else if (ValidationUtil.isNotNullAndNotEmpty(res.retStr)) {
                this._wAlertStore.dispatch(
                    setWAlert({
                        wAlert: {
                            icon: WAlertConstant.cancelled,
                            message: ConvertUtil.convertToSring(res.retStr),
                        },
                    })
                );
            }
            this._overlayLoadingStore.dispatch(
                setShowOverlayLoading({ loading: false })
            );
        });

        this._overlayLoadingStore
            .select(getLoading)
            .subscribe((res) => (this.loading = res));
        this._cartStore
            .select(getIsBuyNow)
            .subscribe((res) => (this.isBuyNow = res));
        this._cartStore
            .select(getShowAlert)
            .subscribe((res) => (this.showAlert = res));
        this._cartStore.select(getReload).subscribe((res) => {
            if (res) {
                this.loadCart();
                this._cartStore.dispatch(setReload({ reload: false }));
            }
        });

        this.loadCart();

        this.cartInfo$.subscribe((res) => {
            if (ValidationUtil.isNotNullAndNotEmpty(res)) {
                this.cartInfo = res;
                this.sumPdtCnt = this.cartInfo.sumPdtCnt;
            } else {
                this.sumPdtCnt = 0;
            }
        });
        this.memberPoint$.subscribe((res) => (this.memberPoint = res));
        this.activeCateName = sessionStorage.getItem('cateName') + '';

    }

    loadMainMenu(): void {
        this._overlayLoadingStore.dispatch(
            setShowOverlayLoading({ loading: true })
        );
        this.subMenu = [];

        //this.changeTitlePage('더조각 - AI 뷰티사이언스테크 전문기업');

        this.kind = this.kindMenuHome;
        if (this.baseUrl === this.urlMyOffice) {
            this.kind = this.kindMenuOffice;
            this.activeTopLeft = this.officeId;
            this._pageHeadingStore.dispatch(
                setTypePageHeading({ payload: PageHeadingConstants.typeOP })
            );
            //this.menuHeaderName = 'My Office';
        } else if (this.baseUrl === this.urlShopping) {
            this.kind = this.kindMenuShopping;
            this.activeTopLeft = this.homeId;
            //this.menuHeaderName = 'Shop';
        } else if (this.baseUrl === this.urlAbout) {
            this.kind = this.kindMenuAbout;
            this.activeTopLeft = this.about;

        } else if (this.baseUrl === this.urlCompany) {
            this.kind = this.kindMenuHome;
            this.activeTopLeft = this.homeId;
            this._pageHeadingStore.dispatch(
                setTypePageHeading({ payload: PageHeadingConstants.typeHP })
            );
        } else {
            this.activeTopLeft = '';
            if (this.url == '/') {
                this._pageHeadingStore.dispatch(
                    setTypePageHeading({ payload: PageHeadingConstants.typeSP })
                );
            } else {
                if (!this.url.startsWith('/login') && !this.url.includes("/servicePage") && !this.url.includes("/company")) {
                    this.kind = this.kindMenuFooter;
                }

                this._pageHeadingStore.dispatch(
                    setTypePageHeading({ payload: PageHeadingConstants.typeHP })
                );
            }
        }

        this.treeMainMenu = new Map();

        if (this.kind === this.kindMenuOffice || this.kind === this.kindMenuFooter || this.kind === this.kindMenuHome) {
            this.loadMainMyOfficeAndHomeMainMenu(this.mainMenu, this.kind);
        } else {
            this.loadMainShoppingMenu(this.pdtCates, this.kind);
        }

        this.mainItems = Array.from(this.treeMainMenu.values());

        this.setActiveId();

        this._overlayLoadingStore.dispatch(
            setShowOverlayLoading({ loading: false })
        );

        setTimeout(() => baseJS(), 1);

        // this.flagJS++;
        // if (typeof addEventListenerForMobileMenu === 'function') {
        //     setTimeout(() => addEventListenerForMobileMenu(), 1000);
        //     setTimeout(() => adjustSidebarActiveMenuItemLiPosition(), 1100);
        //     if(this.flagJS == 1){
        //       setTimeout(() => baseJS(), 1100);
        //   }
        // }

        if (typeof addEventListenerClickButtonSearch === 'function') {
            setTimeout(() => {
                addEventListenerClickButtonSearch();
            }, 500);
        }

    }
    handleSetLang(): void {
        let lang = ConvertUtil.convertToSring(
            sessionStorage.getItem(LangConstant.STR_LANG)
        );

        if (ValidationUtil.isNotNullAndNotEmpty(lang)) {
            let selectedOption = this.options.filter(
                (y) => y.value == lang
            );

            if (selectedOption.length > 0) {
                this.selected = selectedOption[0];
            } else {
                this.selected = this.options[0];
            }
        } else {
            this.selected = this.options[0];
        }
        sessionStorage.setItem(LangConstant.STR_LANG, this.selected.value + '');

    }
    setDataTreeMainMenu(item: MyProgram): void {
        if (item.menuLv == '1') {
            this.treeMainMenu.set(item.prgId, { data: item, children: [] });
        } else if (item.menuLv == '2') {
            const node = this.treeMainMenu.get(item.pid);
            if (node?.children !== undefined && node?.children !== null) {
                node.children.push({ data: item, children: [] });
            }
            this.subMenu.push(item);
        }
    }

    loadMainMyOfficeAndHomeMainMenu(items: MyProgram[], kind: string): void {
        this.tempActiveId = '';
        let item;
        for (let i = 0; i < items.length; i++) {
            item = items[i];
            if (item.prgKind == kind) {
                this.setDataTreeMainMenu(item);
            }
            if (item.menuLv == '1' && item.linkInfo === this.url) {
                this.tempActiveId = item.prgId;
            }
            this.updateTitleByUrl(item);
        }
    }

    loadMainShoppingMenu(items: PdtCateModel[], kind: string): void {

        let item;
        let itemsTmp: PdtCateModel[] = [];
        let items2: PdtCateModel = {} as PdtCateModel;
        let items3: PdtCateModel = {} as PdtCateModel;
        // items2.cateCd = 'All';
        // items2.cateName = 'All';
        // items2.linkInfo = '/All';
        // items2.lv = '2';
        // items2.total= '0';
        // itemsTmp.push(items2);

        for (const pdt of items) {
            itemsTmp.push(pdt);
        }

        items3.cateCd = 'wish';
        items3.cateName = '관심상품';
        items3.lv = '1';
        items3.total = '0';
        itemsTmp.push(items3);

        for (const pdtCate of itemsTmp) {

            // if(this.chkMemEdu == 'N' && pdtCate.cateCd == '0115') {
            //     continue;
            // }
            item = this.convertToMyProgram(
                pdtCate,
                kind,
                MyProgramConstant.urlShopping + '/category/' + pdtCate.cateCd
            );

            this.setDataTreeMainMenu(item);
            this.updateTitleByUrl(item);
        }
    }

    convertToMyProgram(
        item: PdtCateModel,
        kind: string,
        linkInfo: string
    ): MyProgram {
        return {
            comId: item.comId,
            prgId: item.cateCd,
            prgName: item.cateName,
            pid: item.pcd,
            prgKind: kind,
            menuYn: 'Y',
            menuLv: (+item.lv).toString(),
            linkInfo: linkInfo,
            loginYn: 'A',
            cnt: item.total,
            consumerYn: 'Y'
        } as MyProgram;
    }

    setActiveId(): void {
        let havePageHeading = false;
        this.activeId = '';
        this.activeChildId = '';

        if (ValidationUtil.isNotNullAndNotEmpty(this.subMenu)) {
            for (const item of this.subMenu) {
                if (
                    item.linkInfo === this.url &&
                    (item.prgKind === this.kindMenuOffice ||
                        item.prgKind === this.kindMenuHome ||
                        item.prgKind === this.kindMenuFooter
                    )
                ) {
                    this.activeId = item.pid;
                    this.activeChildId = item.prgId;
                    const node = this.treeMainMenu.get(this.activeId);
                    if (node !== undefined && node !== null) {
                        havePageHeading = true;
                        this._pageHeadingStore.dispatch(
                            setPageHeading({ node: node, child: item, pathname: this.url })
                        );
                    }
                }
            }
        }
        if (!havePageHeading) {
            if (PageHeadingConstants.MAP_LINK_W_LEFT_MENU.has(this.url)) {
                let menuName = PageHeadingConstants.MAP_LINK_W_LEFT_MENU.get(this.url);
                for (const item of this.subMenu) {
                    if (item.linkInfo === menuName) {
                        const node = this.treeMainMenu.get(item.pid);
                        if (node !== undefined && node !== null) {
                            this._pageHeadingStore.dispatch(
                                setPageHeading({
                                    node: node,
                                    child: item,
                                    pathname: item.linkInfo,
                                })
                            );
                        }
                    }
                }
            } else {
                this._pageHeadingStore.dispatch(setShowPageHeading({ show: false }));
            }
        }

        if (this.kind === this.kindMenuShopping) {
            let category: any = sessionStorage.getItem("category");
            if (ValidationUtil.isNotNullAndNotEmpty(category)) {
                this.activeId = category;
            }
        } else {

            //sessionStorage.removeItem('category');

        }

        if (
            ValidationUtil.isNullOrEmpty(this.activeId) &&
            ValidationUtil.isNullOrEmpty(this.activeChildId) &&
            ValidationUtil.isNotNullAndNotEmpty(this.tempActiveId)
        ) {
            this.activeId = this.tempActiveId;
        }
    }

    initMainMenu(url: string): void {
        // setTimeout(() => {
        //   if (typeof updateMainSidebarWitdth === "function") {
        //     updateMainSidebarWitdth(url);
        //   }
        // }, 100);

        if (AuthUtil.isLogined()) {
            this.isLogined = true;
        } else {
            this.isLogined = false;
        }

        let tm = setInterval(() => {
            this.loginedInfo = AuthUtil.getLoginedInfo();
            if (this.loginedInfo) {
                clearInterval(tm);
            }
        }, 100);

        let tempUrl: string[] = [];

        this.url = url;
        tempUrl = this.url.split('/');
        if (tempUrl.length >= 2) {
            this.baseUrl = '/' + tempUrl[1];
        }

        this.loadMainMenu();
    }

    handleOnClickRightMenu(item: MyProgram): void {

        if (item.linkInfo == '/logout') {
            this._loginStore.dispatch(logout());
            localStorage.removeItem('member');
            localStorage.removeItem('lastAction');
            sessionStorage.removeItem('category');

            location.href = '/';
        } else {
            this._router.navigate([item.linkInfo]);
        }
    }

    handleOnClickLeftMenu(item: MyProgram) {

        if (AuthUtil.isLogined()) {
            if (this.userKind == '00') {
                this._router.navigate([MyProgramConstant.urlMyOffice + '/order-management/order-search']);
            } else {
                this._router.navigate([item.linkInfo]);
            }
        } else {
            this._router.navigate(['/login']);
        }
    }

    handleOnSearch(): void {
        if (ValidationUtil.isNotNullAndNotEmpty(this.key)) {
            this._router.navigateByUrl(
                MyProgramConstant.urlShopping + `/product-search?key=${this.key}`
            );
        } else {
            this._router.navigate([MyProgramConstant.urlShopping]);
        }
        if (typeof clickBtnSearchClose === 'function') {
            clickBtnSearchClose();
        }
    }
    // LANG
    languages: string[] = ["EN"];
    lang: string = CommonUtils.getLang();

    handleOnActiveLangItem(): void {
        const tm = setInterval(() => {
            // const lang = sessionStorage.getItem(LangConstant.STR_LANG);
            const lang = CommonUtils.getLangMessage();
            if (lang) {
                const _div = document.getElementById("language-items");
                if (_div) {
                    const _as = Array.from(_div.getElementsByClassName('language') as HTMLCollectionOf<HTMLInputElement>);
                    for (const _a of _as) {
                        if (ConvertUtil.convertToSring(_a.getAttribute("data-lang")).toLowerCase() === lang.toLowerCase()) {
                            _a.classList.add("active");
                        }
                    }
                }
                this.lang = CommonUtils.getLangMessage();

                clearInterval(tm);
            }
        }, 100);
    }

    loadCart(): void {

        if (AuthUtil.isLogined()) {
            let member = AuthUtil.getLoginedInfo();
            if (member) {
                this._cartStore.dispatch(
                    loadCartInfo({
                        userid: ConvertUtil.convertToSring(member.userid),
                        ctrCd: ConvertUtil.convertToSring(member.ctrCd),
                    })
                );
                this._cartStore.dispatch(
                    loadCartItems({ userid: ConvertUtil.convertToSring(member.userid) })
                );
                this._memberPointStore.dispatch(
                    loadMemberPoint({ userid: ConvertUtil.convertToSring(member.userid) })
                );
            }
        }
    }

    removeUrlParams(url: string): string {
        if (ValidationUtil.isNotNullAndNotEmpty(url)) {
            return url.split('?')[0];
        }
        return location.pathname;
    }

    updateTitleByUrl(item: MyProgram): void {
        if(this.url.includes("/ALL")) {
            this.changeTitlePage('더조각 - 상품목록 | 전체');
        } else if (item.linkInfo === this.url) {
            if (this.url.includes("/company")) {
                this.changeTitlePage('더조각 - ' + item.prgName);
            } else if (this.url.includes("/category")) {
                this.changeTitlePage('더조각 - 상품목록 | ' + item.prgName);
            }
        }
    }

    changeTitlePage(title: string): void {
        var _title = document.querySelector('title');
        if (_title) {
            _title.innerText = title;
        }
    }

    @HostListener('document:mousedown', ['$event'])
    onGlobalClick(event: any): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.showOptions = false;
        }
    }

    handleOnClickSelectDropdown(): void {
        this.showOptions = !this.showOptions;
    }

    handleOnClickOption(lang: SelectDropdownModel): void {
        if (lang.value == 'jp') {
            //window.open('https://mediusjpn.com', '_blank');
            return;
        } else if (lang.value == 'th') {
            //window.open('https://www.mediusth.com', '_blank');
            return;
        } else if (lang.value == 'en') {
            window.open('https://us.iamglobalnet.com/', '_blank');
            return;
        }

        this.selected = lang;
        this.showOptions = false;
        if (ValidationUtil.isNullOrEmpty(lang.value)) return;
        sessionStorage.setItem(LangConstant.STR_LANG, lang.value + '');
        location.reload();
    }

    handleOnClickCategory(item: any) {
        sessionStorage.removeItem("category");
        this._pdtCateStore.dispatch(setPdtCate({ cate: item.cateCd }));
        this._productStore.dispatch(setCateCd({ cateCd: item.cateCd }));
        this._router.navigate([`/shopping-mall/category/` + ConvertUtil.convertToSring(item.cateCd)]);
    }

    handleClickMenu(item: any) {
        if (item.prgId == 'mh.Mall') {
            sessionStorage.removeItem("category");
            this._pdtCateStore.dispatch(setPdtCate({ cate: this.cateDefault }));
            this._productStore.dispatch(setCateCd({ cateCd: this.cateDefault }));
            this._router.navigate([`/shopping-mall/category/${this.cateDefault}`]);
        } else {
            this._router.navigate([ConvertUtil.convertToSring(item.linkInfo)]);
        }
    }

    cycleNames() {
        setInterval(() => {
            this.currentName = this.memberNames[this.currentIndex];
            this.currentIndex = (this.currentIndex + 1) % this.memberNames.length;
        }, 5000);
    }
}
